import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
    getAll,
    clearUsersList,
    getNonUsersList,
    showCustomNotificationPopup,
    getApprovedCompaniesList,
} from '../actions/notificationsActions';
import { getIsPageVisible } from '../selectors/mainSelectors';

import NotificationHeader from '../components/manageNotifications/notificationsHeader';
import NotificationsTable from '../components/manageNotifications/notificationsTable';

class ManageNotifications extends React.Component {
    state = {
        selectedCompanyId: null,
    };

    componentDidMount() {
        this.props.getApprovedCompaniesList(company => {
            if (company) {
                this.getUsers(company.id);
                this.setState({
                    selectedCompanyId: company.id,
                });
            }
        });
    }

    getUsers = value => {
        if (value === 'non-users') {
            return this.props.getNonUsers();
        }

        return this.props.getCompanyUsers(value);
    };

    onSelectorChange = e => {
        const { value } = e.target;

        const company = value === 'non-users' ? null : this.props.companies.find(c => +c.id === +value);

        this.setState(
            {
                selectedCompanyId: company ? company.id : null,
            },
            () => this.getUsers(value),
        );
    };

    showNotificationPopup = () => {
        this.props.showCustomNotificationPopup();
    };

    render() {
        if (!this.props.isPageVisible) {
            return null;
        }

        const company = this.props.companies.find(c => +c.id === +this.state.selectedCompanyId);

        return (
            <div>
                <NotificationHeader
                    companies={this.props.companies}
                    showNotificationPopup={this.showNotificationPopup}
                    selectedCompany={this.state.selectedCompanyId}
                    onSelectorChange={this.onSelectorChange}
                />
                <NotificationsTable
                    selectedCompanyId={this.state.selectedCompanyId}
                    marketId={company ? company.market_id : null}
                    isBroker={company ? company.is_broker : false}
                    isApprovedCompany={company ? !!company.approved : true}
                />
            </div>
        );
    }
}

ManageNotifications.propTypes = {
    isPageVisible: PropTypes.bool.isRequired,
    companies: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

    showCustomNotificationPopup: PropTypes.func.isRequired,
    getApprovedCompaniesList: PropTypes.func.isRequired,
    getNonUsers: PropTypes.func.isRequired,
    getCompanyUsers: PropTypes.func.isRequired,
};

export default connect(
    state => ({
        companies: state.notifications.companies,
        user: state.user,
        isPageVisible: getIsPageVisible(state),
    }),
    dispatch => ({
        getNonUsers: () => {
            dispatch(getNonUsersList());
            dispatch(clearUsersList());
        },
        getCompanyUsers: id => {
            dispatch(getAll(id));
            dispatch(getNonUsersList());
        },
        showCustomNotificationPopup: () => {
            dispatch(showCustomNotificationPopup());
        },
        getApprovedCompaniesList: cb => {
            dispatch(getApprovedCompaniesList(cb));
        },
    }),
)(ManageNotifications);



// WEBPACK FOOTER //
// ./source/screens/ManageNotifications.js